import { jsxs as e, jsx as l } from "react/jsx-runtime";
const i = () => /* @__PURE__ */ e(
  "svg",
  {
    width: "100",
    height: "100",
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M100 50C100 77.6145 77.6145 100 50 100C22.3855 100 0 77.6145 0 50C0 22.3855 22.3855 0 50 0C77.6145 0 100 22.3855 100 50Z",
          fill: "#F2DFE1"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M36.15 72C34.964 72 34 71.036 34 69.85V29.15C34 27.964 34.964 27 36.15 27H66.85C68.036 27 69 27.964 69 29.15V69.85C69 71.036 68.036 72 66.85 72H36.15Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ l(
        "mask",
        {
          id: "mask0_7393_26496",
          maskUnits: "userSpaceOnUse",
          x: "33",
          y: "26",
          width: "37",
          height: "47",
          children: /* @__PURE__ */ l(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M33 26H69.9999V73H33V26Z",
              fill: "white"
            }
          )
        }
      ),
      /* @__PURE__ */ l("g", { mask: "url(#mask0_7393_26496)", children: /* @__PURE__ */ l(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M66.85 26H36.15C34.41 26 33 27.41 33 29.15V69.85C33 71.59 34.41 73 36.15 73H66.85C68.59 73 70 71.59 70 69.85V29.15C70 27.41 68.59 26 66.85 26ZM66.85 28C67.484 28 68 28.516 68 29.15V69.85C68 70.484 67.484 71 66.85 71H36.15C35.516 71 35 70.484 35 69.85V29.15C35 28.516 35.516 28 36.15 28H66.85Z",
          fill: "#49565D"
        }
      ) }),
      /* @__PURE__ */ l(
        "mask",
        {
          id: "mask1_7393_26496",
          maskUnits: "userSpaceOnUse",
          x: "33",
          y: "26",
          width: "37",
          height: "47",
          children: /* @__PURE__ */ l("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M33 73H70V26H33V73Z", fill: "white" })
        }
      ),
      /* @__PURE__ */ e("g", { mask: "url(#mask1_7393_26496)", children: [
        /* @__PURE__ */ l(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M58 40H65V38H58V40Z",
            fill: "#49565D"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M38 40H55V38H38V40Z",
            fill: "#49565D"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M38 34H65V32H38V34Z",
            fill: "#49565D"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M47 46H65V44H47V46Z",
            fill: "#49565D"
          }
        )
      ] }),
      /* @__PURE__ */ l(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M25 64C25 56.269 31.268 50 39 50C46.731 50 53 56.269 53 64C53 71.732 46.731 78 39 78C31.268 78 25 71.732 25 64Z",
          fill: "#B00020"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M40.6686 57.5L40.1777 66.7853H37.8292L37.3383 57.5H40.6686ZM40.2258 71.2189C39.9307 71.5072 39.52 71.6513 38.9938 71.6513C38.4548 71.6513 38.0377 71.5103 37.7426 71.2284C37.4474 70.9464 37.2998 70.5488 37.2998 70.0356C37.2998 69.5034 37.4442 69.1011 37.7329 68.8286C38.0217 68.5562 38.442 68.42 38.9938 68.42C39.5264 68.42 39.9387 68.5594 40.2306 68.8381C40.5226 69.1169 40.6686 69.5161 40.6686 70.0356C40.6686 70.5362 40.521 70.9306 40.2258 71.2189Z",
          fill: "white"
        }
      )
    ]
  }
);
export {
  i as ReportDailyFailedIllustration
};
//# sourceMappingURL=index.es474.js.map
